import axios from 'axios'
import qs from 'qs'
import baseUrl from './env'
axios.defaults.withCredentials = true

axios.defaults.baseURL = baseUrl
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
const service = axios.create({
  timeout: 8000
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)
function http(config) {
  if (config.method === 'post') {
    config.data = qs.stringify(config.data, {
      arrayFormat: 'repeat',
      allowDots: true
    })
  } else {
    config.params = config.data
  }
  return service(config)
}

export default http
